import { useState } from 'react';

import { Spin } from 'antd';

import WordForm from './word-form';

import TitledCard from '../../../layout-components/titled-card';

const NewWord: React.FC = () => {
  const [loading, setLoading] = useState(false);

  return (
    <Spin spinning={loading}>
      <TitledCard title="Nowe słowo" backUrl="..">
        <WordForm setLoading={setLoading} />
      </TitledCard>
    </Spin>
  );
};
export default NewWord;
